/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["mi",[["AM","PM"]],u,[["Rt","M","T","W","T","P","Rh"],["Rāt","Man","Tūr","Wen","Tāi","Par","Rāh"],["Rātapu","Mane","Tūrei","Wenerei","Tāite","Paraire","Rāhoroi"],["Rāt","Man","Tū","Wen","Tāi","Par","Rāh"]],u,[["H","P","M","Ā","M","H","H","Ā","H","O","N","T"],["Hān","Pēp","Māe","Āpe","Mei","Hun","Hūr","Āku","Hep","Oke","Noe","Tīh"],["Hānuere","Pēpuere","Māehe","Āpereira","Mei","Hune","Hūrae","Ākuhata","Hepetema","Oketopa","Noema","Tīhema"]],[["H","P","M","Ā","M","H","H","Ā","H","O","N","T"],["Hān","Pēp","Māe","Āpe","Mei","Hun","Hūr","Āku","Hep","Oke","Noe","Tīh"],["Hānuere","Pēpuere","Māehe","Āperira","Mei","Hune","Hūrae","Ākuhata","Hepetema","Oketopa","Noema","Tīhema"]],[["BCE","CE"]],1,[6,0],["dd-MM-y","d MMM y","d MMMM y","EEEE, d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"NZD","$","Tāra o Aotearoa",{"NZD":["$"],"USD":["US$","$"]},"ltr", plural];
